import defaultMoment from "moment-timezone";
import moment from 'moment-timezone';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {Box} from "@mui/material";
import { renderTimeViewClock } from '@mui/x-date-pickers-pro';

interface DatePickerProps {
	dateFormat: string;
	dateTimeFormat?: string;
	label?: string;
	disabled?: boolean;
	onChange: (date: defaultMoment.Moment | null, value?: string | null | undefined) => void;
	timeFormat?: string;
	minDate?: defaultMoment.Moment;
	maxDate?: defaultMoment.Moment;
	selected?: defaultMoment.Moment;
	dataType?: string;
	placeholder?: string;
	error?: string;
	mandatory?: boolean;
	classes: any;
	name?: string;
	important?: string;
	className?: string;
	helperText?: string;
}

class NewDatePicker extends window.React.PureComponent<DatePickerProps> {
	constructor(props: DatePickerProps) {
		super(props);
		moment.locale(window?.Alfresco?.constants?.JS_LOCALE ?? 'cs');
	}

	getActions(mandatory: boolean | undefined): ('clear' | 'cancel' | 'accept')[] {
		const actions: ('clear' | 'cancel' | 'accept')[] = ['cancel', 'accept'];
		if (!mandatory) {
			actions.unshift('clear');
		}
		return actions;
	}

	// @ts-ignore
	static defaultProps: DatePickerProps = {
		dataType: 'date',
		dateFormat: window.Edocat.Config?.dateFormat || window.Edocat.texts?.dateTimeFormat,
		dateTimeFormat: window.Edocat.Config?.dateTimeFormat,
		mandatory: false,
	};

	render() {
		const {
			dateFormat,
			label,
			disabled,
			minDate,
			maxDate,
			dataType,
			dateTimeFormat,
			selected,
			placeholder,
			error,
			onChange,
			mandatory,
			name,
			important,
			helperText,
			className,
		} = this.props;

		const customLocaleText = {
			cancelButtonLabel: window.Alfresco.messages.global['button.cancel'],
			clearButtonLabel: window.Alfresco.messages.global['button.clear'],
			okButtonLabel: window.Alfresco.messages.global['button.ok'],
		};

		//
		// console.log(moment(selected))
		// console.log(selected && moment(selected)?.isValid())
		// const dateError =
		// 	selected && !(selected.hasOwnProperty('_isValid') ? selected : moment(selected))._isValid
		// 		? window.Alfresco.messages.global['Alfresco.forms.validation.date.message']
		// 		: '';
		return (
			<Box className="Global-Date-Picker" sx={{".MuiPickersTextField-root": {marginRight: "0px"}, ".MuiPickersSectionList-root": {fontSize: "0.75rem !important", padding: ".75rem 0 .75rem !important"}}}>
				{dataType === 'date' ? (
					<LocalizationProvider
						adapterLocale={window.Alfresco.constants.JS_LOCALE}
						dateAdapter={AdapterMoment}
						localeText={customLocaleText}
					>
						<DatePicker
							name={name}
							label={label}
							value={selected ? moment(selected) : null}
							onChange={(value) => onChange(value ? value.startOf('day') : value)}
							format={dateFormat}
							minDate={minDate ? moment(minDate) : undefined}
							maxDate={maxDate ? moment(maxDate) : undefined}
							disabled={disabled}
							slotProps={{
								textField: {
									id: name,
									className: className,
									required: mandatory,
									error: !!error, //|| !!dateError,
									helperText: error /*|| dateError*/ || important || helperText,
									placeholder: placeholder,
									variant: 'outlined',
									InputLabelProps: {
										shrink: true,
									},
									sx: {
										backgroundColor: 'transparent',
										marginRight: '5px',
									},
								},
								actionBar: {
									actions: this.getActions(mandatory),
								},
							}}
						/>
					</LocalizationProvider>
				) : (
					<LocalizationProvider
						adapterLocale={window.Alfresco.constants.JS_LOCALE}
						dateAdapter={AdapterMoment}
						localeText={customLocaleText}
					>
						<DateTimePicker
							ampm={false}
							name={name}
							label={label}
							value={selected ? moment(selected) : null}
							onChange={(value) => onChange(value ?? null)}
							format={dateTimeFormat}
							minDate={minDate ? moment(minDate) : undefined}
							maxDate={maxDate ? moment(maxDate) : undefined}
							disabled={disabled}
							viewRenderers={{
								hours: renderTimeViewClock,
								minutes: renderTimeViewClock,
							}}
							slotProps={{
								textField: {
									id: name,
									className: className,
									required: mandatory,
									error: !!error, //|| !!dateError,
									helperText: error /*|| dateError*/ || important || helperText,
									placeholder: placeholder,
									variant: 'outlined',
									InputLabelProps: {
										shrink: true,
									},
									sx: {
										backgroundColor: 'transparent',
										marginRight: '5px',
									},
								},
								actionBar: {
									actions: this.getActions(mandatory),
								},
							}}
						/>
					</LocalizationProvider>
				)}
			</Box>
		);
	}
}

export default NewDatePicker;
